import { useState, useEffect } from "react";
import axios from "axios";
import { Apiurl } from "../../../shared/services/apirest";
import { getAuthHeader } from "../utils/investigadorUtils";

export const useInvestigadorStats = () => {
    const [stats, setStats] = useState({ total: 0, active: 0, highRisk: 0, riskData: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await axios.get(`${Apiurl}casos/`, getAuthHeader());
                const data = res.data;

                const total = data.length;
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                const active = data.filter(c => new Date(c.fecha_registro) >= thirtyDaysAgo).length;

                const highRiskCount = data.filter(c => c.nivel_peligrosidad === 'ALTO').length;
                const highRisk = total > 0 ? ((highRiskCount / total) * 100).toFixed(1) : 0;

                const riskCounts = { ALTO: 0, MEDIO: 0, BAJO: 0 };
                data.forEach(c => {
                    const risk = c.nivel_peligrosidad || 'BAJO';
                    if (riskCounts[risk] !== undefined) riskCounts[risk]++;
                });

                const riskData = [
                    { name: 'Alto', cantidad: riskCounts.ALTO, fill: '#EF5350' },
                    { name: 'Medio', cantidad: riskCounts.MEDIO, fill: '#FFA726' },
                    { name: 'Bajo', cantidad: riskCounts.BAJO, fill: '#66BB6A' },
                ];

                setStats({ total, active, highRisk, riskData });
            } catch (err) {
                console.error("Error loading stats:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    return { stats, loading };
};
